import { getJWTTokens, setJWTokens, isTokenExpired } from '@shared/libs';
import { refreshAccessToken } from '@features/auth/api/refresh';
import { jwtDecode } from 'jwt-decode';

export const ensureValidAccessToken = async () => {
  const { accessToken, refreshToken, email, groupName } = getJWTTokens();

  if (accessToken && !isTokenExpired(accessToken)) return accessToken;

  if (!refreshToken || isTokenExpired(refreshToken)) return;

  try {
    const newTokens = await refreshAccessToken(refreshToken);
    const { group_name } = jwtDecode<{ group_name: string }>(newTokens.access_token);
    setJWTokens(email ?? '', newTokens.access_token, newTokens.refresh_token, group_name || groupName || '');
    return newTokens.access_token;
  } catch {
    return;
  }
};
